const CHAT360_SCRIPT_ID = 'chat360-script-ui-components';
export const injectChatScript = (accessToken) => {
    // Ensuring to not inject again the same script
    if (document.getElementById(CHAT360_SCRIPT_ID) || accessToken === undefined) {
        return;
    }
    const script = document.createElement('script');
    script.src = '/public/sf.js';
    script.id = CHAT360_SCRIPT_ID;
    script.type = 'text/javascript';
    script.setAttribute('data-position', JSON.stringify({
        right: 40,
        bottom: 60,
    }));
    script.setAttribute('data-endpoint', JSON.stringify({
        token: '/advisormetrics/api/v2/chat/token',
        prechat: '/advisormetrics/api/v2/chat/connect360chatprefill',
        access_token: accessToken,
    }));
    document.body.appendChild(script);
};
